import { Api } from "laravel-request";

import type { ApiResponse } from "./types/api.types";
import type { ApiErrorCallback } from "./types/legacyCallbacks";

export type DuplicateResolveAction = "dry" | "hard" | "soft" | "marking" | "merge";
export type DuplicateSearchAction = "standard" | "name_and_email" | "user";

export interface DuplicateUserDTO {
    user_id: number;
    crm_application_id: number | null;
    crm_contact_id: number | null;
    user_manager_id: number | null;
    user_email: string | null;
    user_created_at: string | null;
    password_status: string;
    crm_contact_user_id: number | null;
    crm_contact_email: string | null;
    crm_contact_first_name: string | null;
    crm_contact_last_name: string | null;
    crm_contact_middle_name: string | null;
    crm_contact_is_actual: number | null;
    crm_contact_aton_id: string | null;
    crm_contact_created_at: string | null;
    contact_match: string;
    crm_application_status_id: number | null;
    crm_application_source_id: number | null;
    crm_application_responsible_user_id: number | null;
    crm_application_comment: string | null;
    crm_application_created_at: string | null;
    application_match: string;
    duplicate_position: number;
    deletion_candidate: string;
}

export interface DuplicateSelectionPayload {
    user_id: number;
    crm_contact_id: number | null;
    crm_application_id: number | null;
}

export const getUserDuplicates = (
    searchAction: DuplicateSearchAction,
    onSuccess: (data: DuplicateUserDTO[]) => void,
    onError?: ApiErrorCallback,
    selection?: DuplicateSelectionPayload[] | null
): void => {
    const payload: Record<string, any> = {
        search_action: searchAction,
    };

    if (selection && selection.length > 0) {
        payload.selection = selection;
    }

    Api.get("duplicate", "index-duplicates", payload).all(
        (response: ApiResponse<DuplicateUserDTO[]>) => {
            const data = Array.isArray(response?.data) ? response.data : [];
            onSuccess(data);
        },
        onError as (xhr: XMLHttpRequest, responseData?: any) => void
    );
};

export const runDeduplicate = (
    resolveAction: DuplicateResolveAction,
    searchAction: DuplicateSearchAction,
    selection: DuplicateSelectionPayload[] | null,
    onSuccess?: () => void,
    onError?: ApiErrorCallback
): void => {
    const payload: Record<string, any> = {
        resolve_action: resolveAction,
        search_action: searchAction,
    };

    if (selection && selection.length > 0) {
        payload.selection = selection;
    }

    Api.post("duplicate", "deduplicate", payload).call(
        () => {
            onSuccess?.();
        },
        (error: any) => {
            onError?.(error);
        }
    );
};
